import Case from "@repo/utils/Case";

type FeatureFlag = {
  name: FeatureFlag.Name;
  pass: boolean;
};

namespace FeatureFlag {
  export type Name = Case.ToCamel<Case.FromSnake<FeatureFlagCanada.Name | FeatureFlagUsa.Name>>;
}

export default FeatureFlag;


export namespace FeatureFlagCanada {
  export const names = [];
  export type Name = (typeof names)[number];
  export namespace Name {
    export const normalize = (name: string) =>
      Case.fromSnake(name).toCamel() as FeatureFlag.Name;

    export const denormalize = (name: FeatureFlag.Name) =>
      Case.fromCamel(name).toSnake();
  }
}

export namespace FeatureFlagUsa {
  export const names = ["community", "community_credit_scores"] as const;
  export type Name = (typeof names)[number];

  export namespace Name {
    export const normalize = (name: string) =>
      Case.fromSnake(name).toCamel() as FeatureFlag.Name;

    export const denormalize = (name: FeatureFlag.Name) =>
      Case.fromCamel(name).toSnake();
  }
}
